import axios from "axios";
import router from "@/router";
import {
	Message
} from "element-ui";

const service = axios.create({
	timeout: 50 * 1000
});

// ================= Token 闸门 =================
// 问题：queryToken 是异步的，子组件 mounted 时可能 token 还没拿到，
// 导致并发请求带不上 token。用一个 Promise 让所有非 token 请求排队等 token 就绪。
// queryToken 成功后调 releaseTokenGate() 放行。
let tokenReady = !!localStorage.getItem("token");
let tokenWaitPromise = null;
let tokenWaitResolve = null;

function ensureWaitPromise() {
	if (!tokenWaitPromise) {
		tokenWaitPromise = new Promise((resolve) => {
			tokenWaitResolve = resolve;
		});
	}
}
// 初始若没有 token，进入等待态
if (!tokenReady) ensureWaitPromise();

// queryToken 完成（无论成功失败）后调用，放行所有排队请求
export function releaseTokenGate() {
	tokenReady = true;
	if (tokenWaitResolve) tokenWaitResolve();
	tokenWaitPromise = null;
	tokenWaitResolve = null;
}

// ================= 请求拦截 =================
service.interceptors.request.use(
	async (config) => {
		// queryToken 自己不阻塞，避免死锁
		const isTokenRequest = config.url && config.url.indexOf("/api/queryToken") !== -1;
		if (!isTokenRequest && !tokenReady && tokenWaitPromise) {
			// 等 queryToken 把 token 写进 localStorage
			await tokenWaitPromise;
		}
		// 统一 header 基础字段（合并而非覆盖，避免丢失 axios 自动设置的 Content-Type 等）
		const headers = config.headers || {};
		const token = localStorage.getItem("token");
		const authorization = localStorage.getItem("authorization");
		if (typeof headers.set === "function") {
			headers.set("company-code", 9);
			headers.set("token", token);
			headers.set("Authorization", authorization);
		} else {
			headers["company-code"] = 9;
			headers["token"] = token;
			headers["Authorization"] = authorization;
		}

		config.headers = headers;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// ================= 响应拦截 =================
service.interceptors.response.use(
	(response) => {
		const {
			code
		} = response.data || {};

		if (!code) return response.data;

		switch (code) {
			case 212:
				router.push("/");
				break;

			case 1001:
			case 408:
				router.replace("/logins");
				break;

			case 203:
				// 未输入搜索内容
				break;

			default:
				break;
		}

		return response.data;
	},
	(error) => {
		if (!error.response) {
			if (error.message === "Network Error") {
				Message.error({
					message: "网络异常，请重试",
					center: true
				});
			} else if (error.message.includes("timeout")) {
				Message.error({
					message: "服务器响应超时，请重试",
					center: true
				});
			} else {
				Message.error("连接服务器失败");
			}
			return Promise.reject("连接服务器失败");
		}

		const status = error.response.status;
		let message = "";

		switch (status) {
			case 400:
				message = error.response.data?.msg || "请求错误";
				break;
			case 401:
				message = "未授权，请重新登录";
				break;
			case 402:
				message = "未授权，请申请授权";
				break;
			case 403:
				message = "拒绝访问";
				break;
			case 404:
				message = "请求错误，未找到该资源";
				break;
			case 405:
				message = "请求方法未允许";
				break;
			case 408:
				message = "请求超时";
				break;
			case 412:
				message = "签名校验未通过，请重试";
				break;
			case 500:
				message = "服务器端出错";
				break;
			default:
				message = `连接错误(${status})`;
		}

		Message.error({
			message,
			center: true
		});
		return Promise.reject(message);
	}
);

export default service;